import React from "react";
import styles from "../StatCards/StatCards.module.css";
import {
  FaCheckCircle,
  FaHandshake,
  FaUsers,
  FaCalendarAlt,
} from "react-icons/fa";

const StatsCards = () => {
  const cards = [
    {
      id: 1,
      icon: <FaCheckCircle />,
      title: "Profile Completion",
      value: "75%",
    },
    {
      id: 2,
      icon: <FaHandshake />,
      title: "Membership Validity",
      value: "245 Days",
    },
    { id: 3, icon: <FaUsers />, title: "Papers Published", value: "12" },
    {
      id: 4,
      icon: <FaCalendarAlt />,
      title: "Mentor Points",
      value: "Dec 2026",
    },
  ];

  return (
    <div className={styles.cardsRow}>
      {cards.map((c) => (
        <div key={c.id} className={styles.card}>
          <div className={styles.icon}>{c.icon}</div>
          <div>
            <h4 className={styles.cardTitle}>{c.title}</h4>
            <p className={styles.cardValue}>{c.value}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsCards;
